import remove from '@/components/remove'

var mixin = {
  components: {
    "remove-dialog": remove
  },
  methods: {
    remove(item, callback = this.load) {
      this.deletedItem = item;
      this.api.delete(item.id).then(response => {
        this.queue(callback())
      })
    },
    softDelete(item, callback = this.load) {
      this.deletedItem = item;
      this.api.archive(item.id).then(response => {
        this.queue(callback())
      })
    }
  }
}

export default mixin;
